/**
 * How full is the sea — the single definition of the water's surface height.
 *
 * Pure and framework-free (C-6) so it is unit-tested without a DOM, and shared by
 * both layouts (Horizon and Ledger) so the two screens can never drift on what
 * "full" means.
 *
 * The level is **spending, and nothing else** (DESIGN_SYSTEM §4.1 — "Spending
 * raises the sea"). It is deliberately independent of the Horizon drag-sheet: the
 * sheet slides up *over* the water, it does not raise it. `ratio` is spent ÷
 * budget from `usePeriodView`, so over-budget (`ratio > 1`) floods past the top,
 * up to the engine's own flood cap.
 */

/** A thin decorative band so the palace is never bone-dry, even at zero spend. */
export const WATER_FLOOR = 0.08;

/** Matches the engine's flood cap (`setLevel` clamps to 1.06); a hair under. */
export const WATER_CAP = 1.04;

/**
 * The water surface height for a period, 0..{@link WATER_CAP}.
 *
 * With no budget set there is no line to be measured against, so the water rests
 * at the decorative floor rather than pretending to a fullness it cannot know.
 */
export function waterLevel(hasAnyBudget: boolean, ratio: number): number {
  if (!hasAnyBudget) return WATER_FLOOR;
  return Math.min(WATER_CAP, Math.max(WATER_FLOOR, ratio));
}
